import React, { Component } from 'react'

class Footer extends Component {

    render() {
        return (
            <div>
                {/* LINE Membership CTA */}
                <div className="footer_line_cta">
                    <div className="footer_line_inner">
                        <span className="footer_line_text">加入 LINE 官方帳號，享會員集點及專屬優惠</span>
                        <a href="https://line.me/R/ti/p/%40015hnwem" className="footer_line_btn" target="_blank" rel="noopener noreferrer">
                            加入好友
                        </a>
                    </div>
                </div>

                <footer>
                    <div className="footer_content">
                        <div className="footer_col footer_brand">
                            <img
                                src={process.env.PUBLIC_URL + "/image/doday_logo_copy.png"}
                                className="footer_logo"
                                alt="DoDay Logo"
                            />
                            <p className="footer_tagline">好日子，壞日子，都有豆日子</p>
                            <div className="footer_social">
                                <a href="https://www.instagram.com/doday_official/?hl=zh-tw" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                                    <img src={process.env.PUBLIC_URL + "/image/instagram.png"} alt="Instagram"/>
                                </a>
                                <a href="https://www.facebook.com/pg/豆日子doday-106167927822106/posts/" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                                    <img src={process.env.PUBLIC_URL + "/image/facebook.png"} alt="Facebook"/>
                                </a>
                            </div>
                        </div>

                        <div className="footer_col">
                            <h3>快速連結</h3>
                            <a href="/">主頁</a>
                            <a href="/about">關於我們</a>
                            <a href="/menu">菜單</a>
                            <a href="/contact">聯絡我們</a>
                            <a href="/order">線上點餐</a>
                        </div>

                        <div className="footer_col">
                            <h3>店舖資訊</h3>
                            <p>台北市文山區木柵路二段149號一樓</p>
                            <p>營業時間: 11:30 - 22:00</p>
                            <p>訂購專線: 02 86617800</p>
                        </div>

                        <div className="footer_col">
                            <h3>外送平台</h3>
                            <div className="footer_delivery">
                                <a href="https://www.ubereats.com/tw/store/doday-%E8%B1%86%E6%97%A5%E5%AD%90%E8%B1%86%E8%8A%B1%E7%94%9C%E5%93%81%E5%BA%97-%E6%9C%A8%E6%9F%B5%E5%89%B5%E5%A7%8B%E5%BA%97/1oM8GcEMR7GI2LwFmoKNyQ" target="_blank" rel="noopener noreferrer">Uber Eats</a>
                                <a href="https://www.foodpanda.com.tw/chain/cc3jt/dou-ri-zi-dou-hua-tian-pin-dian" target="_blank" rel="noopener noreferrer">Foodpanda</a>
                                <a href="https://order.doday.com.tw" target="_blank" rel="noopener noreferrer">官方訂餐</a>
                            </div>
                            <h3 style={{marginTop: '20px'}}>聯絡信箱</h3>
                            <a href="mailto:contact@nexuni.com">contact@nexuni.com</a>
                        </div>
                    </div>

                    <div className="footer_bottom">
                        Copyright &copy; {new Date().getFullYear()} 豆日子 DoDay 豆花甜品店. All rights reserved.
                    </div>
                </footer>
            </div>
        );
    }
}

export default Footer;
